import React from 'react'
import styles from './rsvp-title.scss'
import PropTypes from 'prop-types'

const RsvpTitle = ({ title, subTitle, description }) => (
  <div>
    <h3 className={styles['rsvp-title']}>{title}</h3>
    {subTitle && <div className={styles['rsvp-sub-title']}>{subTitle}</div>}
    {description && <div className={styles['rsvp-description']}>{description}</div>}
  </div>
)

RsvpTitle.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  subTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
}

export default RsvpTitle
